import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { RedirectService } from '../services/redirect.service';

/**
 * Redirects /home to root /
 *
 * Note: Localized home redirects (/de/home → /de) are handled by storyblokStoryGuard
 * which processes all Storyblok content and strips "home" from translated paths.
 */
export const homeRedirectGuard: CanActivateFn = route => {
  const redirectService = inject(RedirectService);
  return redirectService.redirectTo([''], { replaceUrl: true, queryParams: route.queryParams });
};
